const openNewWindowActions = [
  "redirect",
  "smsShare",
  "facebookShare",
  "messengerShare",
  "linkedInShare",
  "mailtoShare",
  "nativeMobileShare",
  "twitterShare",
  "whatsAppShare",
  "googleWalletLink",
  "appleWalletDownload",
];

const WIDGET_CONTAINER_SELECTOR = ".Widget-container";

export { openNewWindowActions, WIDGET_CONTAINER_SELECTOR };

export const QR_CODE_CHANNEL = "qr";
export const GOOGLE_WALLET_CHANNEL = "googleWallet";
export const GOOGLE_WALLET_CLICK_EVENT_NAME = "add_to_google_wallet";
export const APPLE_WALLET_CHANNEL = "appleWallet";
export const APPLE_WALLET_CLICK_EVENT_NAME = "add_to_apple_wallet";
